module.exports = __webpack_public_path__ + "img/comefrotreat.part(12) 1.f92bacdf.svg";